"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ColumnConfig_1 = tslib_1.__importDefault(require("./ColumnConfig"));
const fmko_ts_common_1 = require("fmko-ts-common");
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
class RadioGroupColumnConfig extends ColumnConfig_1.default {
    constructor(args) {
        super(args);
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        const id = fmko_ts_common_1.GlobalCounter.next();
        const that = this;
        let initiallySelectedInput;
        this.renderer = {
            render(ctx, obj) {
                const { data, selected } = obj;
                const radioButton = new fmko_ts_widgets_1.WCAGRadioButton({
                    checkedInitially: selected,
                    checkedValue: data,
                    label: args.mapDataToLabel?.(data) ?? "",
                    retainLabelSize: true
                });
                const { row } = ctx;
                radioButton.getFieldElement().setAttribute("name", id);
                if (selected) {
                    that.setValue(data, false);
                    that.selectedRowNumber = row;
                    initiallySelectedInput = radioButton.getFieldElement();
                }
                radioButton.addValueChangeHandler((event) => {
                    that.setValue(event.getValue(), true);
                    that.selectedRowNumber = row;
                    that.updateSelectionCSSState();
                });
                ctx.setWidget(radioButton);
            },
            canRender(_o) {
                return true;
            },
            postRender() {
                if (args.focusInitiallySelected) {
                    initiallySelectedInput?.focus();
                }
                initiallySelectedInput = undefined;
                that.updateSelectionCSSState();
            }
        };
    }
    getData(data) {
        return { data: data, selected: !!this.mapDataToTD(data) };
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    getSelectedRowNumber() {
        return this.selectedRowNumber;
    }
    getValue() {
        return this.value;
    }
    setValue(newValue, fireEvents) {
        const oldvalue = !!this.value ? JSON.parse(JSON.stringify(this.value)) : this.value;
        this.value = newValue;
        if (fireEvents) {
            fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, oldvalue, newValue);
        }
    }
    updateSelectionCSSState() {
        for (let i = 0; i < this.grid.getRowCount(); i++) {
            const dataOnRow = this.grid.dataManager.getDataRow(i);
            const selected = this.getValue();
            if (dataOnRow === selected) {
                this.grid.addRowStyle(i, "table-row-selected");
            }
            else {
                this.grid.removeRowStyle(i, "table-row-selected");
            }
            if (i > this.selectedRowNumber) {
                this.grid.addRowStyle(i, "table-row-after-selected");
            }
            else {
                this.grid.removeRowStyle(i, "table-row-after-selected");
            }
        }
    }
}
exports.default = RadioGroupColumnConfig;
//# sourceMappingURL=RadioGroupColumnConfig.js.map